// extracted by mini-css-extract-plugin
export default {"box__image":"BoxImage_box__image__mn6DQ"};